import { FaArrowRight } from "react-icons/fa";

// components
import HomeBanner from "@/components/banners/HomeBanner";
import ContentLayout from "@/layouts/ContentLayout";
import ContactUsForm from "@/components/ContactUsForm";

// assets
import banner from "@/assets/images/home/banner.png";
import whyPlanetrus from "@/assets/images/home/why-planetrus.png";
import workWithUs from "@/assets/images/home/work-with-us.png";
import contactUs from "@/assets/images/home/contact-us.png";
import fryer from "@/assets/images/home/fryer.jpeg";
import map from "@/assets/images/home/map.png";
import homeImage1 from "@/assets/images/home/homeImage1.png";
import homeImage2 from "@/assets/images/home/homeImage2.png";
import homeImage3 from "@/assets/images/home/homeImage3.png";
import homeImage4 from "@/assets/images/home/homeImage4.png";
import homeImageZh2 from "@/assets/images/home/homeImageZh2.png";
import homeImageZh3 from "@/assets/images/home/homeImageZh3.png";
import homeImageZh4 from "@/assets/images/home/homeImageZh4.png";

// i18n
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t, i18n } = useTranslation();

  const isZhCn = i18n.language === "zh_CN";

  return (
    <div className="w-full">
      <HomeBanner bannerImg={banner} title={t("home.transforming_waste_into_renewable_energy")} />
      <ContentLayout>
        <article className="flex w-full flex-col gap-6">
          <div className="w-full">
            <p className="text-2xl font-extrabold leading-9 text-primary">{t("home.about_us")}</p>
            <div className="mt-3 flex flex-col gap-3">
              <p className="line text-normal font-normal md:text-4xl md:leading-[48px]">
                {t("home.about_us_description")}
              </p>
            </div>
            <button
              className="mt-6 flex items-center rounded-md bg-primary px-6 py-3 text-base font-bold text-white"
              onClick={() => window.open("/about-us/about-planetrus", "_self")}
            >
              {t("home.read_more")} <FaArrowRight className="rtl-icon-flip inline" style={{ marginInlineStart: "0.5rem" }} />
            </button>
          </div>
        </article>
      </ContentLayout>

      <section className="w-full bg-[#F0F0F3] px-4 py-12 md:px-6 lg:px-12">
        <div className="mx-auto max-w-7xl">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {/* Card 1 */}
            <figure className="group h-full overflow-hidden rounded-md bg-white shadow-md transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg">
              <figure className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={homeImage1}
                  alt="fryer"
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </figure>
              <div className="p-6">
                <p className="text-base leading-relaxed text-gray-700">{t("home.mission_statement")}</p>
              </div>
            </figure>

            {/* Card 2 */}
            <figure className="group h-full overflow-hidden rounded-md bg-white shadow-md transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg">
              <figure className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={isZhCn ? homeImageZh2 : homeImage2}
                  alt="fryer"
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </figure>
              <div className="p-6">
                <p className="text-base leading-relaxed text-gray-700">{t("home.hands_on_commitment")}</p>
              </div>
            </figure>

            {/* Card 3 */}
            <figure className="group h-full overflow-hidden rounded-md bg-white shadow-md transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg">
              <figure className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={isZhCn ? homeImageZh3 : homeImage3}
                  alt="fryer"
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </figure>
              <div className="p-6">
                <p className="text-base leading-relaxed text-gray-700">{t("home.one_stop_purchasing_services")}</p>
              </div>
            </figure>

            {/* Card 4 */}
            <figure className="group h-full overflow-hidden rounded-md bg-white shadow-md transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg">
              <figure className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={isZhCn ? homeImageZh4 : homeImage4}
                  alt="fryer"
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </figure>
              <div className="p-6">
                <p className="text-base leading-relaxed text-gray-700">
                  {t("home.7_24_365_year_round_instant_communication")}
                </p>
              </div>
            </figure>
          </div>
        </div>
      </section>

      <section className="flex w-full items-center justify-center bg-white">
        <figure className="h-auto w-full border bg-white md:w-[1600px]">
          <img src={map} alt="map" className="h-full w-full object-contain md:object-cover" />
        </figure>
      </section>
      <div className="relative mx-auto w-full max-w-[2000px] md:h-[480px]">
        <img src={workWithUs} alt="work-with-us" className="hidden h-full w-full object-cover md:flex" />
        <div className="inset-0 md:absolute md:mx-[120px] md:my-[60px] md:flex">
          <div className="w-full rounded-lg bg-[#f0f0f3]/70 p-6 md:p-9">
            <p className="text-2xl font-extrabold leading-9 text-primary">{t("home.work_with_us.title")}</p>
            <p className="mt-6 text-4xl font-bold leading-[48px]">{t("home.work_with_us.subtitle")}</p>
            <p className="mt-6 text-lg font-normal leading-[24px]">{t("home.work_with_us.description")}</p>
            <button
              className="mt-6 flex items-center rounded-md bg-primary px-6 py-3 text-base font-bold text-white"
              onClick={() => window.open("/about-us/meet-our-team", "_self")}
            >
              {t("home.read_more")} <FaArrowRight className="rtl-icon-flip" style={{ marginInlineStart: "0.5rem" }} />
            </button>
          </div>
        </div>
      </div>
      <div className="relative mx-auto w-full max-w-[2000px] md:h-[739px]">
        <img src={contactUs} alt="contact-us" className="hidden h-full w-full object-cover md:flex" />
        <div className="inset-0 rounded-lg bg-[#f0f0f3] p-15 md:absolute lg:mx-[120px] lg:my-[60px]">
          <ContactUsForm />
        </div>
      </div>
    </div>
  );
};

export default Home;
